import {Component, OnInit} from '@angular/core';
import {moduloVMI} from '../../../diccionarios/moduloVMI';
import {AG_GRID_LOCALE_ES} from '../../../diccionarios/spanishAgGrid';
import {VmiEstadoProductoService} from '../../../services/informes/vmi-estado-producto.service';
import {NucleoModel} from '../../../models/vmi-nucleoModel';

@Component({
  selector: 'app-vmi-reporte-estado-producto',
  templateUrl: './vmi-reporte-estado-producto.component.html',
  styleUrls: ['./vmi-reporte-estado-producto.component.css']
})
export class VmiReporteEstadoProductoComponent implements OnInit {

  modulo: any = {};
  DAT_TITULOS: any;
  titulo: any;
  AG_GRID_LOCALE_ES: any = {};

  lista: NucleoModel[];
  loading: boolean = false;

  constructor(
    private _estadoProducto: VmiEstadoProductoService
  ) {
  }

  ngOnInit(): void {
    this.modulo = moduloVMI;
    this.AG_GRID_LOCALE_ES = AG_GRID_LOCALE_ES;
    this.DAT_TITULOS = this.modulo.titulos.estadoProducto;
    this.titulo = this.DAT_TITULOS.tituloCardListar;
    this.getAll();
  }

  //*SERVICIOS
  getAll() {
    this.loading = true;
    // this._estadoProducto.getEstadoProuctoByCliente('2').subscribe((res: NucleoModel[]) => {
    this._estadoProducto.getAllEstadoProuctoCustom().subscribe((res: NucleoModel[]) => {
      this.lista = res.map(e => {
        e['round'] = Number(e.vmiStockfisico.toFixed(2));
        return e;
      });
      this.loading = false;
    }, (err) => {
      console.log(err);
      this.lista = [];
      this.loading = false;
    });
  }

}
